import gql from 'graphql-tag'

export default gql`
mutation updateArticleDetailLink ($input: ArticleDetailLinkInput) {
  updateArticleDetailLink (input: $input) {
    id
    text
    url
    article_detail_id
  }
}
`



// WEBPACK FOOTER //
// ./src/apollo/graphql/article/updateLink.js